import React, { ErrorInfo } from 'react'
import { Image, ImageStyle, ScrollView, TextStyle, View, ViewStyle } from 'react-native'

import { Button, Text } from '../../components'
import { translate } from '../../i18n'
import { color } from '../../theme'

const CONTAINER: ViewStyle = {
  alignItems: 'center',
  flex: 1,
  padding: 16,
  paddingVertical: 50,
  backgroundColor: color.background
}

const ERROR_DETAILS_CONTAINER: ViewStyle = {
  width: '100%',
  maxHeight: '60%',
  backgroundColor: color.line,
  marginVertical: 15,
  paddingHorizontal: 10,
  paddingBottom: 15,
  borderRadius: 6
}

const BTN_RESET: ViewStyle = {
  paddingHorizontal: 40,

  backgroundColor: color.primary
}

const TITLE_ERROR: TextStyle = {
  color: color.error,
  fontWeight: 'bold',
  paddingVertical: 15
}

const FRIENDLY_SUBTITLE: TextStyle = {
  color: color.palette.black,
  fontWeight: 'normal',
  paddingVertical: 15
}

const CONTENT_ERROR: TextStyle = {
  color: color.error,
  fontWeight: 'bold',
  paddingVertical: 15
}

// Uncomment this and the Text component in the ErrorComponent if
// you want to see a backtrace in your error reporting screen.
// const CONTENT_BACKTRACE: TextStyle = {
//   color: color.dim,
// }

const ICON: ImageStyle = {
  marginTop: 30,
  width: 64,
  height: 64
}

export interface ErrorComponentProps {
  error: Error
  errorInfo: ErrorInfo
  onReset(): void
}

/**
 * Describe your component here
 */
export const ErrorView = (props: ErrorComponentProps) => {
  const buttonTitle = translate('errorScreen.reset')
  return (
    <View style={CONTAINER}>
      <Image style={ICON} source={require('./assets/ladybug.png')} />
      <Text style={TITLE_ERROR} tx={'errorScreen.title'} />
      <Text style={FRIENDLY_SUBTITLE} tx={'errorScreen.friendlySubtitle'} />
      <View style={ERROR_DETAILS_CONTAINER}>
        <ScrollView>
          <Text selectable style={CONTENT_ERROR} text={`${props.error}`} />
          {/* <Text selectable style={CONTENT_BACKTRACE} text={`${props.errorInfo.componentStack}`} /> */}
        </ScrollView>
      </View>
      <Button
        textStyle={{}}
        btnStyle={BTN_RESET}
        icon=""
        colorCode="#ffffff"
        disabled={false}
        name={buttonTitle}
        type=""
        onPress={props.onReset}
      />
    </View>
  )
}
